import React from 'react';
import RouteHeader from '../RouteHeader/routeHeader';
import Card from '../../../Helper/CardWrapper/cardWrapper'
import ContentGrid from '../../../Helper/gridWrapper/gridWrapper';
import {connect} from 'react-redux';
import VisitorsTable from './visitorsTable';
import { withStyles } from '@material-ui/core/styles';
import './visitors.css';

const styles={
    headLine:{
        fontSize: 30,
        fontWeight:500
    }
};

const Visitors = (props)=>{
    const { user,classes } = props;
    return (
        <div className='container-div'>
            <ContentGrid
            header={
                user.results.BusinessUser.IsFirstVisit && JSON.parse(user.results.BusinessUser.IsFirstVisit)['Visitors']?
                <RouteHeader title={'Visitors'}
                             text={`If you see someone who visits ${user.results.AppUser.FirstName} often, feel free to send them a message.
                                  People love personality.`}
                             width='100%'
                />:<span/>
            }
            content={
                <Card
                    header={'Check Ins'}
                    CardHeaderProps={{
                        classes: {
                            title:classes.headLine
                        }
                    }}
                    content={
                        <VisitorsTable />
                    }
                    CardContentProps={{
                        style: {borderTop: '1px solid #ddd'}
                    }}
                />
            }
        />
        </div>
    )
};
const mapStateToProps=(state)=> {
    return {
        user:state.loginResponse
    }
};
export default connect(mapStateToProps,null)(withStyles(styles)(Visitors));